<template>
        <section>
            <div class="container">
                <div class="header">
                    <div class="row align-items-center">
                        <div class="col">
                        <div class="user-avatar">
                            <div class="img-avatar" :style="{'background-image': 'url('+item.noticiero_img+'),url('+defaultImage+')'}" ></div>
                            <div class="data-avatar">
                            <p class="user-name noticieroName">{{item.noticiero_nombre}}</p>
                            <p class="user"><a class="user verde" :href="item.media" target="_blank">{{'https://www.youtube.com/'+item.key_src}}</a></p>
                            </div>
                        </div>
                        </div>
                        <div class="col-auto">
                        <svg class="svgYoutube" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="30px" height="30px"  preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><path d="M10 15l5.19-3L10 9v6m11.56-7.83c.13.47.22 1.1.28 1.9c.07.8.1 1.49.1 2.09L22 12c0 2.19-.16 3.8-.44 4.83c-.25.9-.83 1.48-1.73 1.73c-.47.13-1.33.22-2.65.28c-1.3.07-2.49.1-3.59.1L12 19c-4.19 0-6.8-.16-7.83-.44c-.9-.25-1.48-.83-1.73-1.73c-.13-.47-.22-1.1-.28-1.9c-.07-.8-.1-1.49-.1-2.09L2 12c0-2.19.16-3.8.44-4.83c.25-.9.83-1.48 1.73-1.73c.47-.13 1.33-.22 2.65-.28c1.3-.07 2.49-.1 3.59-.1L12 5c4.19 0 6.8.16 7.83.44c.9.25 1.48.83 1.73 1.73z" /></svg>
                        </div>
                    </div>
                </div>
                <br><br>
                 <div class="video">
                    <youtube class="miyoutube" :video-id="videoId" player-width="100%" player-height="100%"></youtube>
                </div>

              
              
                <div class="post-info">
                    <div class="info-heading">
                        <div class="row align-items-center">
                            <div class="col">
                                <h2 class="post-title" v-html="item.titulo"></h2>
                                <p class="video-type blanco"> 
                                    
                                    {{ getFechaSeparada(item.fecha).fecha }}
                                    <br>
                                    {{ getFechaSeparada(item.fecha).hora }}

                                </p>
                            </div>
                            <div class="col-auto">
                                <!--<button class="button screenshot-button tooltip tooltip-left" data-tooltip="Captura">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-camera"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path><circle cx="12" cy="13" r="4"></circle></svg>
                                </button>-->
                            </div>
                        </div>
                    </div>
                    <div class="content">
                        <p v-html="item.descripcion"></p>
                        <div class="row actions align-items-center">
                            <div class="col">
                                <div class="button-container">
                                    <button :class="[{'active':like},'video-action']" >
                                        <svg  viewBox="0 0 24 24" 
                                            fill="none" 
                                            stroke="currentColor" 
                                            stroke-width="2" 
                                            stroke-linecap="round" 
                                            stroke-linejoin="round">
                                            <path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 
                                                2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 
                                                2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3">
                                            </path>
                                        </svg>
                                        <span></span> 
                                    </button>
                                    <button :class="[{'active':dislike},'video-action']" >
                                        <svg viewBox="0 0 24 24" 
                                            stroke="currentColor" 
                                            stroke-width="2" 
                                            stroke-linecap="round" 
                                            stroke-linejoin="round">
                                            <path d="M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 
                                                2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 
                                                2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17">
                                            </path>
                                        </svg>
                                        <span></span>
                                    </button> 
                                     <button :class="[{'active':dislike},'video-action']" >
                                        <svg fill="currentColor" aria-hidden="true" focusable="false" stroke="currentColor" data-prefix="fas" data-icon="info-circle" class="svg-inline--fa fa-info-circle fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path  d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"></path></svg>
                                        <span></span>
                                    </button>
                                </div>
                            </div>
                            <div class="col-auto">
                                <div class="rating">
                                    <div class="stars">
                                        <label  :class="stars[i-1]" v-for="i in 4" :key="i"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12 .288l2.833 8.718h9.167l-7.417 5.389 2.833 8.718-7.416-5.388-7.417 5.388 2.833-8.718-7.416-5.389h9.167z"/></svg></label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="keywords">
                            <!--<div class="chip iconed">
                                Ilustración
                                <button class="icon">
                                    <svg  viewBox="0 0 24 24"  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                                </button>
                            </div>-->
                           

                        </div>
                        <div class="comments">
                            <h2>Comentarios</h2>
                            <div class="row" v-for="comment in comments" :key="comment.key">
                                <div class="col-sm-12">
                                    <p v-html="comment.comentario"></p>
                                    <span class="sub">{{getFecha(comment.created)}}</span>    
                                </div>
                            </div>
                        </div>
                    
                        <div class="divider"></div>
                         <div class="page-actions">
                            <button class="button small outline" v-if="from2" @click="goBack">Regresar</button>
                        </div>
                    </div>
                    
                </div>
            </div>
        </section>
</template>

<script>

import moment from 'moment-timezone'

export default {
    name:'youtubeNote',
    props:['item','comments','noStars','like','dislike','from','fromParams'],
    data () {
        return {
            url : this.$store.getters.getMainUrl,
            videoId:'',
            showModal:false,
            stars:['star','star','star','star'],
            videoId:'',
            defaultImage:this.$store.state.defaultYoutube,
            from2:null
        }
    },
    beforeMount(){
        var backData2 = this.$store.state.backData2;
        this.from2 = backData2.length>0?backData2[backData2.length-1].from:null;
        var id_arr = this.item.media.split('?');
        var id_arr2 = id_arr[1].split('=');
        this.videoId = id_arr2[1];
        var item = this.item;
 
    },
    mounted(){
        this.setStars();
    },
    methods:{
        setStars(noStars){
            var noStars = this.noStars;
            this.pintaStars(noStars);
        },
        pintaStars(noStars){
            if(noStars!=undefined){
                this.resetStars();
                for(var i=0;i<noStars;i++){
                    this.stars[i] += ' active';
                }
            }
        },
        resetStars(){
            this.stars = ['star','star','star','star'];
        },
        getFechaSeparada(){
            moment.tz.setDefault('America/Mexico_City');
            var  tmp =  moment(fecha);
            var f = moment.tz(tmp,'America/Mexico_City').format('DD/MM/YYYY HH:mm:ss');
            var arr = f.split(' ');
            return {
                fecha:arr[0],
                hora:arr[1]
            }
            
        },
        getFecha(fecha){
            moment.tz.setDefault('America/Mexico_City');
            var  tmp =  moment(fecha);
            var f = moment.tz(tmp,'America/Mexico_City').format('DD-MM-YYYY HH:mm:ss');
            return f;
        },
        playVideo(){
            this.activeVideo = true;
        },
        goBack(){
             var backData2 = this.$store.state.backData2;
           
            var data = backData2.pop();
    
            if(data == undefined) {
                this.$router.back();
            }
            else{
                var from = data.from;
                var params = data.fromParams;
            if(from == 'publicNotas'){
                  this.$router.back();
              }else{
                this.$router.push({
                    name:from,
                    params:params
                });
              }
            }
            /*switch(this.from){
                case 'folder':  this.$router.push({name:'public',params:{type:'folder', data:this.fromParams}}); break;
                case 'notas':  this.$router.push({name:'publicNotas',params:{from:this.fromParams.from,params:this.fromParams.params,query:this.fromParams.query}}); break;
            }*/
        }
    }
}
</script>
<style scoped>

.sub{
    color:#00B99E;
}

#video-post .container .content .actions .video-action.active svg {
    fill :white
}

.video .miyoutube {
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}

.html5-video-player {
    /*background: transparent!important;*/
    border-radius: 15px 15px 0 0 !important;
}


</style>